module.exports = __webpack_public_path__ + "img/38.c635c73f.jpg";